import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useSession from "../../hooks/useSession";
import { RoutePath } from "../../utility/Constant";
import Loading from "../shared/loading/Loading";

function UserAuth({ children }) {
  const [user, loading] = useSession();
  const location = useLocation();
  const { homeBanner } = RoutePath;

  if (loading) {
    return <Loading />;
  }

  if (user?.name) {
    return (
      <Navigate to={`/${homeBanner}`} state={{ from: location }} replace />
    );
  }

  return children;
}

export default UserAuth;
